export default __webpack_public_path__ + "static/plastic_injection-2fb101cb3d36f5e024388e69af5979f6.jpg";